import UiDemo from './UiDemo.jsx';

export default () => {
    return {
        path: '/UiDemo',
        element: <UiDemo />,
    }
}